/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ContractsInputs */

const en_nav_contracts = /** @type {(inputs: Nav_ContractsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contracts`)
};

const es_nav_contracts = /** @type {(inputs: Nav_ContractsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contratos`)
};

/**
* | output |
* | --- |
* | "Contracts" |
*
* @param {Nav_ContractsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_contracts = /** @type {((inputs?: Nav_ContractsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ContractsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_contracts(inputs)
	return es_nav_contracts(inputs)
});